// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"7de584c6","451":"3fab856c","724":"8807fbd4","770":"6a28a8c2"}[chunkId] + ".chunk.css";
};